
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","viewBox":"0 0 19 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 19H2.679c-.908 0-1.643-.895-1.643-2V3c0-1.105.735-2 1.643-2h10.678C14.265 1 15 1.895 15 3v7M5.75 6.25h5.5M5.75 10.25h2.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#00B01C","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.061 15.4l2.539 2.54M12.6 17.939l4.596-4.596"}})])
          )
        }
      }
    